<template>
  <PortfolioPage />
</template>
<script>
import PortfolioPage from "@/components/PortfolioPage.vue";
const components = {
  PortfolioPage,
};
export default {
  name: "Portfolio",
  components,
};
</script>
